import { HttpService } from "@/core";
import { AxiosResponse } from "axios";
import { ResponseResp } from "@/core/interface";
import { message } from "ant-design-vue";
import { AreaListRecord, AreaListResp } from "./location-select.interface";

const cache = {};

export class LocationSelectService {
  static async fetchList(params, isLeaf: boolean = false): Promise<AreaListRecord[]> {
    if (cache[params.parentId]) {
      return cache[params.parentId];
    }
    let records: AreaListRecord[] = [];
    try {
      const r: AxiosResponse<ResponseResp<AreaListResp>> = await HttpService.axios({
        method: "GET",
        url: "/area/list",
        params,
      });
      const res = r.data;
      if (res.respCode !== "0000") {
        message.error(res.respDesc);
        return records;
      }
      records = (res.data.records || []).map((item) => {
        item.isLeaf = isLeaf;
        return item;
      });
      cache[params.parentId] = records;
    } catch (e: any) {
      message.error(e.message);
    }
    return records;
  }

  static attachChildren(list, parentId, children) {
    const recurse = (list, children) => {
      return (list || []).map((item) => {
        if (item.id === parentId) {
          item.children = children || [];
        } else {
          if (item.children) {
            item.children = recurse(item.children, children);
          }
        }
        return item;
      });
    };
    return recurse(list, children);
  }
}
